import { useEffect, useState } from 'react'

import { Search, X } from 'lucide-react'

import { Button } from '@/components/common/Button/Button'
import { Input } from '@/components/common/Input/Input'
import { cn } from '@/utils/cn'

import type { TableSearchProps } from '../DataTable.types'
import { debounce } from '../DataTable.utils'

export const TableSearch: React.FC<TableSearchProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Buscar...',
  debounceMs = 300,
  className
}) => {
  const [localValue, setLocalValue] = useState(value)

  // Debounced onChange
  const debouncedOnChange = debounce(onChange, debounceMs)

  // Update local value when external value changes
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  // Handle local input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setLocalValue(newValue)
    debouncedOnChange(newValue)
  }

  // Handle clear action
  const handleClear = () => {
    setLocalValue('')
    onChange('')
    onClear?.()
  }

  return (
    <div className={cn('relative', className)}>
      <Input
        type="text"
        placeholder={placeholder}
        value={localValue}
        onChange={handleInputChange}
        className="pl-10 pr-10"
        leftIcon={<Search className="h-4 w-4 text-muted-foreground" />}
      />

      {localValue && (
        <Button
          variant="ghost"
          size="sm"
          className="absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 p-0"
          onClick={handleClear}
          aria-label="Limpiar búsqueda"
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  )
}
